import { render, staticRenderFns } from "./relPersonDialog.vue?vue&type=template&id=a0aea6b4"
import script from "./relPersonDialog.vue?vue&type=script&lang=js"
export * from "./relPersonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports